import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { useCallback, useState } from 'react'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import { REGEX_TRIM_ALL_SPACES } from 'src/config/regexp'

interface IUseAmsDataCrudParameters {
  companyName: string
  country: string
  locationId: string
}

export const useAmsDataCrud = ({ companyName, country, locationId }: IUseAmsDataCrudParameters) => {
  const [crud, setCrud] = useState(CrudStore.get(CrudStoreItemOnboarding.AMSSearch))

  const handleSearch = useCallback(() => {
    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'CompanyLegalName',
          value: companyName.replace(REGEX_TRIM_ALL_SPACES, ''),
          operator: Operator.EQUAL,
        },
        {
          field: 'CompanyCountry',
          value: country,
          operator: Operator.EQUAL,
        },
        {
          field: 'LocationID',
          value: locationId.replace(REGEX_TRIM_ALL_SPACES, ''),
          operator: Operator.EQUAL,
        },
      ],
    })

    setCrud(crud)
  }, [companyName, country, locationId, crud])

  return {
    crud,
    handleSearch,
  }
}
